<!-- // banner section \\ -->
<section class="banner-section">
  <img
    class="img-responsive contMinHeight" 
    src="../../../assets/images/contact-us-bg.jpg"
    alt="about-us-banner"
  />
  <div class="comman-width">
    <div class="over">
      <h2>Contact Us</h2>
    </div>
  </div>
</section>
<!-- \\ banner section // -->
<!-- <section class="contact-section">
  <div class="comman-width">
    <app-getcard></app-getcard>
  </div>
</section> -->
<!-- // contact section \\ -->
<section class="contact-section">
  <div class="comman-width">
    <div class="content">
      <form method="post" name="contact_form" action="">
        <div class="left">
          <h2>Write to us</h2>
          <div class="form-group">
            <input
              type="text"
              (focus)="focusValidation('name')"
              name="name"
              id="name_"
              class="form-control"
              placeholder=" "
              autocomplete="off"
              required
            />
            <label for="name_">Name</label>
            <div class="colorRed" *ngIf="emptyInput">Please enter your name</div>
          </div>
          <div class="form-group">
            <input
              type="email"
              name="email"
              id="email_"
              (focus)="focusValidation('email')"
              class="form-control"
              [(ngModel)]="emailmodel"
              placeholder=" "
              autocomplete="off"
              required
            />
            <label for="email_">Email</label>
            <div class="colorRed" *ngIf="emptyEmail">Please enter a valid email address</div>
            <div class="colorRed" *ngIf="invalidEmail">Please enter a valid email address</div>
          </div>
          <div class="form-group destop">
            <label class="checkbox-container"
              >I am not a Robot
              <input
                value="checked"
                name="captcha"
                type="checkbox"
                (change)="checkboxFocusValidation()"
                (click)="onLoginClick(captchaRef)"
              />
              <span class="checkmark"></span>
            </label>
            <div
              class="colorRed"
              *ngIf="emptyCheckbox"
              style="margin-top:30px;"
            >
              Please check this box
            </div>
          </div>
        </div>
        <div class="right">
          <div class="form-group fourth">
            <textarea
              name="message"
              (focus)="focusValidation('message')"
              id="message"
              placeholder=" "
              class="form-control"
            ></textarea>
            <label for="message">Message</label>
            <div class="colorRed" *ngIf="emptyMessage">
              Please enter message
            </div>
          </div>
          <div class="form-group mobile">
            <label class="checkbox-container"
              >I am not robot
              <input
                value="checked"
                name="captcha"
                type="checkbox"
                (change)="checkboxFocusValidation()"
                (click)="onLoginClick(captchaRef)"
              />
              <span class="checkmark"></span>
            </label>
          </div>
          <div class="" id="contactsucess">
            Thanks you for contacting us.
          </div>
          <div class="colorRed" id="contactError">
            Something went wrong.
          </div>
          <div class="clearfix"></div>
          <button
            type="submit"
            class="btn button btn-hover-effect newContactBtn" [class.contactPointer]="submitLoader"
            (click)="validate()"
          >
            <div class="insider"></div>
            <span>Submit</span>  
            <div class="contactLoader" *ngIf="submitLoader"></div>
          </button>
        </div>
      </form>
    </div>
    <p class="captchalink">
      This site is protected by reCAPTCHA and the Google
      <a href="https://policies.google.com/privacy">Privacy Policy</a> and
      <a href="https://policies.google.com/terms">Terms of Service</a>
      apply.
    </p>
    <re-captcha #captchaRef="reCaptcha" (resolved)="resolved($event)" size="invisible"></re-captcha>
  </div>
</section>
<!-- \\ contact section // -->

<!-- // accordian section \\ -->
<section class="accordian-section">
  <div class="comman-width">
    <app-accordian></app-accordian>
  </div>
</section>
<!-- \\ accordian section // -->
